import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import AdminAuthContext from "../store/adminStore/admin-auth-context";

const AdminRequireLoggedIn = ({ route }) => {
  const location = useLocation();
  const { clientAuthInfo } = useContext(AdminAuthContext);

  return (
    <>
      {clientAuthInfo.isLoggedIn ? (
        <Outlet />
      ) : (
        <Navigate to="/admin/login" replace state={{ from: location }} />
      )}
    </>
  );
};

export default AdminRequireLoggedIn;
